import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Calendar, MapPin, ArrowLeft } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";
import { SEO } from "@/components/SEO";
import { Loading } from "@/components/shared";

export default function NewsDetail() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => { api.get(`/public/news/${slug}`).then((r) => setPost(r.data)).catch(() => setErr(true)); }, [slug]);
  const fmt = (d) => d ? new Date(d).toLocaleDateString("en-ZA", { day: "numeric", month: "long", year: "numeric" }) : "";

  if (err) return <div className="mx-auto max-w-3xl px-4 py-24 text-center"><p className="text-slate-500">Post not found.</p><Link to="/news" className="mt-4 inline-block font-bold text-[#1E63D6]">← Back to News</Link></div>;
  if (!post) return <Loading />;

  return (
    <>
      <SEO title={`${post.title} | BJRC News`} description={(post.content || "").replace(/<[^>]+>/g, "").slice(0, 155)} />
      <article className="mx-auto max-w-3xl px-4 py-14 sm:px-6 lg:px-8">
        <Link to="/news" className="inline-flex items-center gap-1 text-sm font-bold uppercase text-[#1E63D6]"><ArrowLeft className="h-4 w-4" /> Back to News</Link>
        {post.category && <span className="mt-6 block text-sm font-bold uppercase tracking-wider text-[#1E63D6]">{post.category}</span>}
        <h1 className="mt-2 font-heading text-4xl font-black uppercase tracking-tight text-[#0B2A4A]">{post.title}</h1>
        <div className="mt-3 flex flex-wrap gap-4 text-sm text-slate-500">
          <span className="flex items-center gap-1"><Calendar className="h-4 w-4" />{fmt(post.event_date || post.publish_date)}</span>
          {post.event_location && <span className="flex items-center gap-1"><MapPin className="h-4 w-4" />{post.event_location}</span>}
        </div>
        {post.featured_image && <img src={mediaUrl(post.featured_image)} alt={post.title} className="mt-6 w-full rounded-2xl object-cover" />}
        <div className="prose prose-slate mt-8 max-w-none whitespace-pre-wrap text-slate-700">{post.content}</div>
      </article>
    </>
  );
}
